var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Form, Field, Input } from '../../Form';
import { resolveTotpChallenge, isBadCode, mfaErrorMessage } from '../../../libs/mfa';
var TotpCodeForm = function (_a) {
    var resolver = _a.resolver, onSuccess = _a.onSuccess, onFailure = _a.onFailure, backToUrl = _a.backToUrl;
    var _b = useState({ hasError: false, error: null, value: '' }), code = _b[0], setCode = _b[1];
    var _c = useState(false), inSubmit = _c[0], setInSubmit = _c[1];
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInSubmit(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, resolveTotpChallenge(resolver, code.value)];
                case 2:
                    _a.sent();
                    onSuccess();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    if (isBadCode(err_1)) {
                        setCode({ hasError: true, error: mfaErrorMessage(err_1), value: code.value });
                        setInSubmit(false);
                        return [2 /*return*/];
                    }
                    setInSubmit(false);
                    onFailure(mfaErrorMessage(err_1));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx("p", { children: "Your account is protected with two-factor authentication. Enter the current code from your authenticator app to continue." }), _jsx(Form, { handleSubmit: function (e) { e.preventDefault(); submit(); }, disabled: code.hasError || code.value.length !== 6 || inSubmit, inSubmit: inSubmit, enableDefaultButtons: true, submitBtnText: "Continue", backToUrl: backToUrl || '/user/profile', children: _jsx(Field, { label: "Verification Code", children: _jsx(Input, { type: "text", name: "totp-code", inputMode: "numeric", autoComplete: "one-time-code", minLen: 6, maxLen: 6, validRegex: "^[0-9]{6}$", customErrorMessage: "Enter the 6-digit code from your authenticator app.", required: true, hasError: code.hasError, error: code.error, changeHandler: setCode }) }) })] }));
};
export default TotpCodeForm;
